module.exports = __webpack_public_path__ + "static/media/territory.38de703c.svg";